import React from 'react';
import {AuthedLayout} from 'components/Layout';

const TermsAndConditionsLazy = React.lazy(() => import(/* webpackChunkName: "TermsAndConditions" */ './TermsAndConditions'));

export const TermsAndConditions = props => <AuthedLayout component={TermsAndConditionsLazy} {...props} />;
